import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
//import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
//import { Security } from "@okta/okta-react";
import { useHistory } from "react-router-dom";
import useSettingsStore from "common/store/SettingsStore";
import { useAuth0 } from "@auth0/auth0-react";

interface IOktaContext {
  isInternalUser: boolean;
  setIsInternalUser: (isInternal: boolean) => void;
}

const OktaContext = createContext<IOktaContext>({
  isInternalUser: false,
  setIsInternalUser: () => {},
});

interface OktaProviderProps {
  children: React.ReactNode;
}

const OktaProvider: React.FC<OktaProviderProps> = ({ children }) => {
  const [isInternalUser, setIsInternalUser] = useState<boolean>(false);

  //const history = useHistory();
  //const { settings } = useSettingsStore();

  //const createOktaAuth = useCallback(
  //  (isInternal: boolean) =>
  //    new OktaAuth({
  //      clientId: isInternal ? settings.oktaClientIdInternal : settings.oktaClientIdExternal,
  //      issuer: isInternal ? settings.oktaIssuerInternal : settings.oktaIssuerExternal,
  //      redirectUri: window.location.origin + "/account/login/callback",
  //      scopes: ["openid", "profile", "email"],
  //      pkce: true,
  //    }),
  //  [settings],
  //);

  //const oktaAuth = useMemo(() => createOktaAuth(isInternalUser), [createOktaAuth, isInternalUser]);

  //const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
  //  history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  //};

  //const triggerLogin = async () => {
  //  await oktaAuth.signInWithRedirect();
  //};

  //const customAuthHandler = async (oktaAuth: OktaAuth) => {
  //  const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
  //  if (!previousAuthState || !previousAuthState.isAuthenticated) {
  //    await triggerLogin();
  //  }
  //};

  return (
    <OktaContext.Provider value={{ isInternalUser, setIsInternalUser }}>
      {/*<Security*/}
      {/*  oktaAuth={oktaAuth}*/}
      {/*  onAuthRequired={() => customAuthHandler(oktaAuth)}*/}
      {/*  restoreOriginalUri={restoreOriginalUri}*/}
      {/*>*/}
        {children}
     {/* </Security>*/}
    </OktaContext.Provider>
  );
};

const useOktaContext = (): IOktaContext => {
  const context = useContext(OktaContext);
  if (!context) {
    throw new Error("useOktaContext must be used within an OktaProvider");
  }
  return context;
};

export { OktaProvider, useOktaContext };
